// executivesData.js

const executivesData = [

  {
    id: 2,
    name: "Marylise Sacco",
    position: "Acting Head of Institution",
    aboutPosition:
      "Marylise oversees academic quality assurance, provides strategic leadership, ensures compliance with standards, & drives innovative initiatives for institutional success.",
    image: "/image-fix/executive-team-images/IMG_8287.JPG",
    resizedimage:
      "/image-fix/executive-team-images/resized-executive-team-meber-images/IMG_8287[1].JPG",
    aboutExecutive:
      "Marylise Sacco, a Maltese accounting & business expert, is the Acting Head of the European School of Business & Diplomacy. A certified ACCA professional with exceptional academic achievements, including first-place in Malta for Financial Management, Marylise possesses extensive experience in corporate finance, human resources, & compliance. Her roles have included Director & Accounting Manager at Aegis Corporate Services, where she excelled in financial reporting, strategic planning, & team leadership. Currently pursuing a BSc (Hons.) Applied Accounting, Marylise blends her technical expertise & leadership acumen to ensure academic excellence, operational efficiency, & strategic growth for the institution.",

    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },
  {
    id: 4,
    name: "Stephen Fenech MBA (Henley)",
    position: "Head of HR and Institutional Operations",
    aboutPosition:
      "The Programmes Consultant designs & evaluates program frameworks, ensures alignment with objectives, & drives impactful solutions for stakeholders.",
    image: "/image-fix/teaching-staff/Stephen-Fenech-MBA-(Henley).jpg",
    resizedimage: "/image-fix/teaching-staff/Stephen-Fenech-MBA-(Henley).jpg",
    aboutExecutive:
      "Stephen Fenech is a Maltese business leader, lecturer and renewable energy consultant with deep experience across finance, operations and HR. He is Managing Director of Natural Power Limited and previously served as HR and Administration Director at the Malta Council for Science and Technology, Esplora. Since 2015 he has advised organisations on strategy, feasibility, funding and project delivery in solar and wider sustainability. Stephen lectures MBA-level finance, leadership and strategy with Malta Leadership Institute and London School of Commerce Malta, and supports dissertation supervision and academic integrity. Earlier he led Bajada Group, delivering Malta’s largest roof mounted photovoltaic plant at 850 kWp, after senior finance roles in tourism, construction and manufacturing. He holds an MSc in Sustainable Energy, an MBA from Henley, and certifications in ISO 9001 internal auditing and CE marking.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },


  {
    id: 4,
    name: "Prof Dr Indra Devi Rajamanoharan ",
    position: "Acting Chair, Academic Board/Senior Lecturer",
    aboutPosition:
      "Oversees academic governance, quality assurance and accreditation; mentors faculty and drives student-success initiatives.",
    image: "/image-fix/executive-team-images/Dr_Indra_Devi_Rajamanoharan.jpg",
    resizedimage:
      "/image-fix/executive-team-images/Dr_Indra_Devi_Rajamanoharan.jpg",
    aboutExecutive:
      "Prof. Dr. Indra Devi Rajamanoharan is an academic leader and educator with experience in programme design, quality assurance, and stakeholder engagement. As Acting Chair of the Academic Board, she leads curriculum review cycles, strengthens assessment and external moderation processes, and ensures alignment with institutional and regulatory standards. As a Senior Lecturer, she focuses on practice-oriented, inclusive teaching and supervision, fostering graduate employability and industry relevance. She has collaborated across departments to implement data-informed improvements in learning and teaching, and continues to advocate for high academic standards and student success.",
    socials: [
      {
        platform: "facebook",
        url: "https://www.facebook.com/emmanuel.addo.507",
      },
      {
        platform: "instagram",
        url: "https://www.instagram.com/emmanuel_addo_/",
      },
      {
        platform: "linkedin",
        url: "https://www.linkedin.com/in/emmanuel-addo-0b1a4a1b2/",
      },
      { platform: "twitter", url: "https://twitter.com/EmmanuelAddo_" },
    ],
  },

  // public/image-fix/executive-team-images/Dr_Indra_Devi_Rajamanoharan.jpg
];

export default executivesData;
